import React, { useState, useEffect, useRef, Component } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";

const AddAnnouncement = () => {
  const token = config.token;
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // ------------------------------------- Input Field state management -------------------------------
  const [teachers, setTeachers] = useState([]);
  const [student, setStudent] = useState([]);
  const [course, setCourse] = useState([]);
  const [classnm, setClassnm] = useState([]);
  const [section, setSection] = useState([]);

  const [anmntTitle, setAnmntTitle] = useState("");
  const [anmntDateTime, setAnmntDateTime] = useState("");
  const [announcementFor, setAnnouncementFor] = useState("class");
  const [selectedClassnm, setSelectedClassnm] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [anmntContents, setAnmntContents] = useState("");

  const handleAnmntTitleChange = (e) => {
    setAnmntTitle(e.target.value);
  };
  const handleAnmntContentsChange = (data) => {
    setAnmntContents(data);
  };
  const handleAnmntDateTimeChange = (e) => {
    setAnmntDateTime(e.target.value);
  };
  const announcementForRadioChange = (event) => {
    setSelectedOption("");
    setSelectedClassnm("");
    setAnnouncementFor(event.target.id);
  };
  const handleSelectedClass = async (e) => {
    await setSelectedClassnm(e.target.value);
    // ----------------------------Fetch section list
    fetch(`${config.host_url}section/${e.target.value}`, {
      method: "POST",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setSection(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching section:", error);
      });
  };
  const handleSelectedAnnouncementForOption = (e) => {
    setSelectedOption(e.target.value);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setAnmntTitle("");
    setAnmntDateTime("");
    setAnmntContents("");
    setSelectedClassnm("");
    setSelectedOption("");

    if (id) {
      navigate("/viewannouncements");
    }
  };

  //--------------------------------------- Fetch teacher, course, class, student ---------------------------------------
  useEffect(() => {
    if (localStorage.usertype !== "teacher") {
      // -----------------Fetch teacher list
      fetch(`${config.host_url}teacher`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setTeachers(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching teacher:", error);
        });

      // -----------------------Fetch course list
      fetch(`${config.host_url}course`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setCourse(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching course:", error);
        });
    }

    // ----------------------Fetch class list
    fetch(`${config.host_url}classes`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setClassnm(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching class:", error);
      });

    // --------------------------Fetch Student list
    fetch(`${config.host_url}student`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setStudent(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching Student:", error);
      });
  }, [token]);

  // ----------------------------------------- set updated value in field if It's edit request -----------------------------------------R
  const updateFieldValueSet = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}announcement/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            const responseData = data.data;
            const originalDate = responseData.datetime;
            const formattedDate = originalDate.replace(".000Z", "");
            setAnmntContents(responseData.content);
            setAnmntDateTime(formattedDate);
            setAnmntTitle(responseData.title);
            setAnnouncementFor(responseData.announcement_for);
            setSelectedClassnm(responseData.classid);
            setSelectedOption(
              responseData.announcement_for === "teacher"
                ? responseData.teacherid
                : responseData.announcement_for === "student"
                ? responseData.studentid
                : responseData.announcement_for === "course"
                ? responseData.courseid
                : responseData.announcement_for === "section"
                ? responseData.sectionid
                : ""
            );
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet();
    }
  }, [id]);

  // ---------------------------------------------- create / add Announcement ----------------------------------------------------c
  // Function to create a new Announcement
  const createAnnouncement = async () => {
    try {
      if (
        !anmntContents.trim() ||
        !anmntTitle.trim() ||
        !anmntDateTime.trim()
      ) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return; // Stop form submission
      }
      if (announcementFor === "class" || announcementFor === "section") {
        if (
          selectedClassnm === "" ||
          selectedClassnm === "undefined" ||
          selectedClassnm === null ||
          !selectedClassnm
        ) {
          triggerNotification("error", "Input fields cannot be empty!!");
          return;
        }
      }
      if (
        announcementFor === "course" ||
        announcementFor === "section" ||
        announcementFor === "student" ||
        announcementFor === "teacher"
      ) {
        if (
          selectedOption === "" ||
          selectedOption === "undefined" ||
          selectedOption === null ||
          !selectedOption
        ) {
          triggerNotification("error", "Input fields cannot be empty!!");
          return;
        }
      }
      //announcementFor validation not require but for safety purpose
      if (announcementFor === null) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      // Validate required fields before making the API request
      fetch(
        `${config.host_url}announcement/${
          id ? decodeURIComponent(atob(id)) : ""
        }`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            title: anmntTitle,
            content: anmntContents,
            datetime: anmntDateTime,
            announcement_for: announcementFor,
            ...(announcementFor === "section" && {
              classid: selectedClassnm,
              sectionid: selectedOption,
            }),
            ...(announcementFor === "class" && {
              classid: selectedClassnm,
            }),
            ...(announcementFor === "student" && {
              studentid: selectedOption,
            }),
            ...(announcementFor === "teacher" && {
              teacherid: selectedOption,
            }),
            ...(announcementFor === "course" && {
              courseid: selectedOption,
            }),
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Announcement created successfully

            triggerNotification(
              "success",
              `Announcement ${id ? "updated" : "created"} successfully.`
            );

            // Reset form fields after successful creation
            setAnmntDateTime("");
            setAnmntContents("");
            setAnmntTitle("");
            navigate("/viewannouncements");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          triggerNotification("error", "Fetch error");
        });
    } catch (error) {
      console.error("Error creating Announcement:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the Announcement."
      );
    }
  };
  return (
    <>
      <Breadcrumb txt="Manage Announcement" subpath={["Add Announcement"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Announcement</h5>
          </div>

          <div className="card-body">
            <form>
              {loading ? (
                <Spinner />
              ) : (
                <>
                  {/* Announcement Title */}
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="amnttitle"
                      id="amnttitle"
                      placeholder="Announcement Title"
                      value={anmntTitle}
                      onChange={handleAnmntTitleChange}
                    />
                    <label htmlFor="amnttitle"> Announcement Title</label>
                  </div>

                  {/* Announcement DateTime */}
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="amntdatetime"
                      id="amntdatetime"
                      placeholder="Announcement Date and Time"
                      value={anmntDateTime}
                      onChange={handleAnmntDateTimeChange}
                    />
                    <label htmlFor="amntdatetime">
                      Announcement Date and Time
                    </label>
                  </div>

                  {/*Announcement for*/}
                  <label className="form-check-label select-none ml-1 mb-2">
                    Announcement For
                  </label>
                  <div>
                    <div className="form-check form-check-inline ml-1">
                      <input
                        defaultChecked
                        name="form-check-group-image"
                        className="form-check-input"
                        type="radio"
                        value=""
                        checked={announcementFor === "class"}
                        id="class"
                        onChange={announcementForRadioChange}
                      />
                      <label
                        className="form-check-label select-none"
                        htmlFor="class"
                      >
                        Class
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        name="form-check-group-image"
                        className="form-check-input"
                        type="radio"
                        value=""
                        checked={announcementFor === "section"}
                        id="section"
                        onChange={announcementForRadioChange}
                      />
                      <label
                        className="form-check-label select-none"
                        htmlFor="section"
                      >
                        Section
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        name="form-check-group-image"
                        className="form-check-input"
                        type="radio"
                        value=""
                        checked={announcementFor === "student"}
                        id="student"
                        onChange={announcementForRadioChange}
                      />
                      <label
                        className="form-check-label select-none"
                        htmlFor="student"
                      >
                        Student
                      </label>
                    </div>
                    {localStorage.usertype !== "teacher" && (
                      <>
                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value=""
                            checked={announcementFor === "teacher"}
                            id="teacher"
                            onChange={announcementForRadioChange}
                          />
                          <label
                            className="form-check-label select-none"
                            htmlFor="teacher"
                          >
                            Teacher
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value=""
                            checked={announcementFor === "course"}
                            id="course"
                            onChange={announcementForRadioChange}
                          />
                          <label
                            className="form-check-label select-none"
                            htmlFor="course"
                          >
                            Course
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="col mt-2">
                    {/* class input field  */}
                    {(announcementFor === "section" ||
                      announcementFor === "class") && (
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select"
                          name="classid"
                          id="classid"
                          aria-label="Select Class"
                          value={selectedClassnm}
                          onChange={handleSelectedClass}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            Select Class
                          </option>
                          {classnm.map((cls) => (
                            <option key={cls.classid} value={cls.classid}>
                              {cls.class}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="classid">Class</label>
                      </div>
                    )}

                    {/* input field for announcement_for */}
                    {announcementFor !== "class" && (
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select"
                          name="classid"
                          id="classid"
                          aria-label="Select Class"
                          value={selectedOption}
                          onChange={handleSelectedAnnouncementForOption}
                        >
                          <option
                            value=""
                            disabled
                            selected
                            className="text-center"
                          >
                            Select{" "}
                            {announcementFor === "section"
                              ? "Section"
                              : announcementFor === "teacher"
                              ? "Teacher"
                              : announcementFor === "student"
                              ? "Student"
                              : announcementFor === "course"
                              ? "Course"
                              : "Announcement For first"}
                          </option>
                          {
                            //section option
                            announcementFor === "section" && section
                              ? section.map((sec) => (
                                  <option value={sec.sectionid}>
                                    {sec.section}
                                  </option>
                                ))
                              : //teacher option
                              announcementFor === "teacher"
                              ? teachers.map((tcr) => (
                                  <option value={tcr.tid}>
                                    {tcr.fname} {tcr.lname}
                                  </option>
                                ))
                              : //student option
                              announcementFor === "student"
                              ? student.map((std) => (
                                  <option value={std.id}>
                                    {std.first_name} {std.last_name}
                                  </option>
                                ))
                              : //course option
                              announcementFor === "course"
                              ? course.map((crs) => (
                                  <option value={crs.course_id}>
                                    {crs.course_name}
                                  </option>
                                ))
                              : ""
                          }
                        </select>
                        <label htmlFor="classid">
                          {announcementFor === "section"
                            ? "Section"
                            : announcementFor === "teacher"
                            ? "Teacher"
                            : announcementFor === "student"
                            ? "Student"
                            : announcementFor === "course"
                            ? "Course"
                            : ""}
                        </label>
                      </div>
                    )}
                  </div>
                </>
              )}

              <div className={loading ? "d-none" : "d-block"}>
                {/* Announcement Content */}
                <label htmlFor="amntcontent" className="mb-2">
                  Announcement Contents
                </label>
                <CKEditor
                  name="amntcontent"
                  editor={ClassicEditor}
                  data={anmntContents}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    handleAnmntContentsChange(data);
                  }}
                />

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={createAnnouncement}
                    >
                      Submit
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAnnouncement;
